module.exports = __webpack_public_path__ + "static/img/turntable.ad845ff.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/turntable.gif
// module id = 1546
// module chunks = 180